import * as React from 'react';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import { FilterMenuPropsBase } from '../../../shared/types/widget-types';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { getWidget } from '..';
import { MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next'

export default function FilterMenu({ button, children }: FilterMenuPropsBase) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const {t} = useTranslation();


  return (
    <React.Fragment>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
        {
          getWidget({
            type: "button",
            label:"Filter",
            startIcon: <FilterAltIcon />,
            variant: "text",
            color: 'secondary',
            onClick: handleClick
          })
        }
      </Box>
      <Menu
        id="account-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        // onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem
          disableRipple={true}
          sx={{
            ":hover": {
              backgroundColor: "transparent",
            },
          }}>
        {
          React.cloneElement(children, {
            ...children.props,
            onClose: (e:any) => {
              handleClose();
            }
        })
        }

        </MenuItem>
        {/* {children.map((item: any) => {
          return <MenuItem>{item}</MenuItem>
        })} */}
      </Menu>
    </React.Fragment>
  );
}